module.exports = __webpack_public_path__ + "img/loginLeft - 副本.22e6a365.png";